import type {
  CreateIntegrationsSyncRunParametersInput,
  SyncValidationsParametersInput,
} from 'generated/resources/graphql'

export type SyncParameters =
  | CreateIntegrationsSyncRunParametersInput[]
  | SyncValidationsParametersInput[]

export type Parameters = Record<string, string>

export const toSyncParameters = (params: Parameters): SyncParameters => {
  return Object.entries(params).map(([key, value]) => ({ key, value }))
}
